export default {
  plural: 'Tags',
  pluralDowncase: 'tags',
  singular: 'Tag',
  new: 'New Tag',
  add: 'Add tags',
  change: 'Change tags',
  createTag: 'Create tag',
  createTeamCustomTag: 'Create team custom tag',
  customTags: 'Custom tags',
  deleteTag: 'Delete tag',
  deleteWarning:
    'Are you sure you want to delete the tag? This action cannot be undone.',
  tagType: 'Tag type',
  select: 'Select tags...',
  removeAllOtherTags: 'Remove all other tags',
  no: 'No tags'
};
